const defaultValue =
  'function InterlockHandler(interlockName)\n' +
  '\tReport("Interlock triggered. Abort")\n' +
  '\tcontrolTcpSocket.Close()\n' +
  '\tSystem.Abort()\n' +
  'end\n' +
  '\n' +
  'Interlocks.MasterEnable = false\n' +
  'Interlocks.Enable(Pin.Din.Interlock1, true)\n' +
  'Interlocks.AssertOnCurrentFlow(Pin.Din.Interlock1, true)\n' +
  'Interlocks.SetInterlockHandler(InterlockHandler)\n' +
  'Interlocks.MasterEnable = true\n' +
  '\n' +
  'kTCP_DATA_SIZE = 64\n' +
  'kTCP_DATA_TIMEOUT = 1000\n' +
  '\n' +
  '\n' +
  'kCMD_GET_STATUS = 1\n' +
  'kCMD_MARK_IMAGE = 2\n' +
  '\n' +
  'kLASER_TYPE_MARK = 1\n' +
  'kLASER_TYPE_POINTER = 2\n' +
  '\n' +
  'kSTATE_UNKNOWN = 0\n' +
  'kSTATE_NOT_READY = 1\n' +
  'kSTATE_IDLE = 2\n' +
  'kSTATE_WAITING_TO_START = 3\n' +
  'kSTATE_MARKING = 4\n' +
  '\n' +
  'function NetworkErrorFunction(message, error)\n' +
  '\tReport("Network Error"..message)\n' +
  'end\n' +
  '\n' +
  'function ImageIndexFromName(imageName)\n' +
  '\tfor key,value in pairs(Images) do\n' +
  '\t\tif (key == imageName) then\n' +
  '\t\t\treturn value\n' +
  '\t\tend\n' +
  '\tend\n' +
  'end\n' +
  '\n' +
  'function MarkImage(imageName, markType)\n' +
  '\tif not (markType == kLASER_TYPE_MARK) then\n' +
  '\t\timageName = imageName.."_Preview"\n' +
  '\tend\n' +
  '\tlocal ImageIndex = ImageIndexFromName(imageName)\n' +
  '\tif not (ImageIndex == nil) then\n' +
  '\t\tIO.WriteDigital(Pin.Dout.MarkInProgress,1,true);\n' +
  '\t\tif (markType == kLASER_TYPE_MARK) then\n' +
  '\t\t\tLaser.PointerDisable()\n' +
  '\t\telse\n' +
  '\t\t\tLaser.PointerEnable()\n' +
  '\t\tend\n' +
  '\n' +
  '\t\tSystem.Flush()\n' +
  '\t\tScanImage(ImageIndex)\n' +
  '\t\tLaser.WaitForEnd()\n' +
  '\t\tReport(imageName.." finished marking")\n' +
  '\t\tIO.WriteDigital(Pin.Dout.MarkInProgress,0,true);\n' +
  '\t\treturn true\n' +
  '\telse\n' +
  '\t\tReport(imageName.." is an invalid image.")\n' +
  '\t\treturn false\n' +
  '\tend\n' +
  'end\n' +
  '\n' +
  '\n' +
  '\n' +
  'System.EnableZCompensation()\n' +
  '\n' +
  'state = kSTATE_UNKNOWN\n' +
  'keep_running = 1\n' +
  'controlTcpSocket = Network.OpenTcpSocket("0.0.0.0", 5033, true, NetworkErrorFunction)\n' +
  'while(keep_running) do\n' +
  '\tdata = controlTcpSocket.Receive(kTCP_DATA_SIZE,kTCP_DATA_TIMEOUT,NetworkErrorFunction)\n' +
  '\tif(data.Length() > 0) then\n' +
  '\t\tif(data[1] == kCMD_GET_STATUS) then\n' +
  '\t\t\tcontrolTcpSocket.Send(state, NetworkErrorFunction)\n' +
  '\t\telseif(data[1] == kCMD_MARK_IMAGE) then\n' +
  '\t\t\tlocal markType = data[2]\n' +
  '\t\t\tdata.Remove(1)\n' +
  '\t\t\tdata.Remove(1)\n' +
  '\t\t\tMarkImage(data.GetString(Encoding.UTF8), markType)\n' +
  '\t\tend\n' +
  '\tend\n' +
  'end\n' +
  'controlTcpSocket.Close()'

export default defaultValue
